import { updateVars, debounce } from './libs/dom'
import Navigation from './modules/nav'
import Sliders from './modules/sliders'
import Cart from './modules/cart/cart'

const onLoad = async () => {
  updateVars()
  new Navigation()
  new Sliders()
  new Cart()

  const agenda = document.querySelector('.s-agenda')
  if (agenda) {
    const cats = agenda.querySelector('.artists__dropdown')
    const btn = agenda.querySelector('.artists button')
    btn.addEventListener('click', () => cats.classList.toggle('is-hidden'))
  }

  const selectArtists = document.querySelector('select#artists')
  if (selectArtists) {
    selectArtists.addEventListener('change', ({ target }) => {
      const url = `${window.location.origin}${window.location.pathname}?artist-id=${target.value}`
      window.location.assign(url)
    })
  }

  const selectGenres = document.querySelector('select#genres')
  if (selectGenres) {
    selectGenres.addEventListener('change', ({ target }) => {
      const url = `${window.location.origin}${window.location.pathname}?genre-slug=${target.value}`
      window.location.assign(url)
    })
  }

  const messages = document.querySelectorAll('.woocommerce-notices-wrapper > *')
  if (messages.length >= 1) {
    messages.forEach((message) => {
      message.addEventListener('click', () => {
        message.style.display = 'none'
      })
    })
  }
}

const onResize = () => {
  requestAnimationFrame(updateVars)
}

const debouncedResize = debounce(onResize, 100)
document.addEventListener('DOMContentLoaded', onLoad)
window.addEventListener('resize', debouncedResize)
